// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1EW-b","large":"styles_large__2_HOe"};